module.exports = __webpack_public_path__ + "img/rtf.87131426.svg";